export default ({ app }, inject) => {
  const storeUtmCampaign = () => {
    if (process.client) {
      const urlParams = new URLSearchParams(window.location.search);
      const utmCampaign = urlParams.get("utm_campaign");
      if (utmCampaign) {
        const c = +new Date();
        localStorage.setItem("utm_campaign", `1;${c};${utmCampaign}`); // version;timestamp;value
      }
    }
  };

  // only do on client because server has no localStorage
  if (process.client) {
    storeUtmCampaign();
  }

  inject("getUtmCampaign", () => {
    if (process.client) {
      return localStorage.getItem("utm_campaign");
    }
    return null;
  });
};
